import { env } from 'process';
import { environment } from '../environments/environment';

export class Apis {
  static userLogin = `${environment.base_url}/user/login/email`;
  static customerSignUp = `${environment.base_url}/customer/signUp`;

  static getProfile = `${environment.base_url}/user/getProfile`;

  static changePassword = `${environment.base_url}/password/changePassword`;
  static forgotPassword = `${environment.base_url}/password/forgotPassword`;

  static sendOTP = `${environment.base_url}/password/forgotPassword/sendOtp`;
  static passwordConditions = `${environment.base_url}/password/conditions`;
  static otpDigits = `${environment.base_url}/otp/getOtpDigitsCount`;
  static getResendOtpDelaySeconds = `${environment.base_url}/otp/getResendOtpDelaySeconds`;

  static refreshToken = `${environment.base_url}/refreshToken`;

  static getUserLogoUrlAndColorCodeForTheme = `${environment.base_url}/getTheme`;

  static accessControl = `${environment.base_url}/accessControl`;
  static byCategory = `${environment.base_url}/accessControl/byCategory`;
  static allAccessControlCategory = `${environment.base_url}/accessControlCategory/all`;

  static initTwoFactor = `${environment.base_url}/twoFactor/init`;
  static validateTwoFactor = `${environment.base_url}/twoFactor/validateTwoFactorOTP`;
  static twoFactorTOTPSetUp = `${environment.base_url}/twoFactor/isTOTPSetUpDone`;
  static initialSetupTwoFactor = `${environment.base_url}/twoFactor/initiateSetupTwoFactor`;
  static setupTwoFactor = `${environment.base_url}/twoFactor/setUpTOtp`;

  static sendMail = `${environment.base_url}/trustedDevice/sendVerificationMailAgain`;

  static allCurrencyList = `${environment.base_url}/currency/all`;

  static generateCode = `${environment.base_url}/charge/generateCode`;
  static getChargeByIdOrCode = `${environment.base_url}/charge/getChargeByIdOrCode`;
  static getPaymentProviderInstrumentByPartnerCode = `${environment.base_url}/paymentInstrument/getByPartnerCode`;

  static countryList = `${environment.base_url}/countries/getAll`;
  static countryListById = `${environment.base_url}/countries/getCountryById`;
  static getOTPSenderImplementation = `${environment.base_url}/otpSenderImpl/getOtpSender`;
  static updateCountryService = `${environment.base_url}/masterUser/countries/updateCountry`;
  static addOtpSender = `${environment.base_url}/masterUser/countries/addOtpSenderImpl`;
  static addCountryAddressSchema = `${environment.base_url}/masterUser/countries/addressSchema`;
  static addBusinessIdentifierSchema = `${environment.base_url}/masterUser/countries/businessIdentifierSchema`;
  static addIndividualIdentifierSchema = `${environment.base_url}/masterUser/countries/individualIdentifierSchema`;
  static addAdminFieldSchema = `${environment.base_url}/masterUser/countries/adminFieldSchema`;
  static addPartnerFieldSchema = `${environment.base_url}/masterUser/countries/partnerFieldSchema`;
  static addCustomerFieldSchema = `${environment.base_url}/masterUser/countries/customerFieldSchema`;
  static addPaymentDetailsFieldSchema = `${environment.base_url}/masterUser/countries/paymentDetailsIdentifierSchema`;
  static updateCountryAddressSchema = `${environment.base_url}/masterUser/countries/updateAddressSchema`;
  static updateBusinessIdentifierSchema = `${environment.base_url}/masterUser/countries/updateBusinessIdentifierSchema`;
  static updateIndividualIdentifierSchema = `${environment.base_url}/masterUser/countries/updateIndividualIdentifierSchema`;
  static updateAdminFieldSchema = `${environment.base_url}/masterUser/countries/updateAdminFieldSchema`;
  static updatePartnerFieldSchema = `${environment.base_url}/masterUser/countries/updatePartnerFieldSchema`;
  static updateCustomerFieldSchema = `${environment.base_url}/masterUser/countries/updateCustomerFieldSchema`;
  static updatePaymentDetailsFieldSchema = `${environment.base_url}/masterUser/countries/updatePaymentDetailsIdentifierSchema`;
  static getDocumentCategoryByUserType = `${environment.base_url}/masterUser/documentCategory/byUserType`;
  static addCountryAsNonMandatoryForDocumentCategory = `${environment.base_url}/masterUser/documentCategory/addCountryAsNonMandatory`;
  static addKycs = `${environment.base_url}/masterUser/countries/addKycs`;
  static disableKyc = `${environment.base_url}/masterUser/kyc/disableKyc`;
  static getKycById = `${environment.base_url}/masterUser/kyc/getKycById`;
  static updateKycById = `${environment.base_url}/masterUser/kyc/updateKycById`;

  static getFieldType = `${environment.base_url}/enums/fieldType`;
  static getFieldSchemaFieldSelectOptionType = `${environment.base_url}/enums/fieldSchemaFieldSelectOptionType`;
  static getComplexFieldOrientation = `${environment.base_url}/enums/complexFieldOrientation`;
  static getSelectOptionFromDB = `${environment.base_url}/selectOptions`;
  static getFieldSchemaValueDetailsForSelectOption = `${environment.base_url}/fieldSchemaValue`;
  static getAwsS3FileType = `${environment.base_url}/enums/AwsS3FileType`;

  static qualifierListById = `${environment.base_url}/qualifier/getQualifierById`;
  static updateQualifierById = `${environment.base_url}/qualifier/updateQualifier`;
  static addChargeById = `${environment.base_url}/charge/addCharge`;
  static updateChargeById = `${environment.base_url}/charge/updateCharge`;
  static addChargeToQualifier = `${environment.base_url}/qualifier/addChargeToQualifier`;
  static addRefundChargeToQualifier = `${environment.base_url}/qualifier/addRefundChargeToQualifier`;
  static addCommissionToQualifier = `${environment.base_url}/qualifier/addCommissionToQualifier`;
  static disableCharge = `${environment.base_url}/charge/disableCharge`;
  static getPaymentProviderImpl = `${environment.base_url}/paymentProvider/get`;

  static getAdminUserList = `${environment.base_url}/masterUser/getAdmins`;
  static getAdminUserListById = `${environment.base_url}/masterUser/admin`;
  static createNewAdminUser = `${environment.base_url}/masterUser/createAdmin`;
  static updateColorAndCustomUrl = `${environment.base_url}/personaliseAdmin/updateColorAndCustomUrl`;
  static logoUploadUrl = `${environment.base_url}/personaliseAdmin/uploadUrl`;
  static publicUrlLogoByDocumentId = `${environment.base_url}/personaliseAdmin/getPublicLogoUrl`;
  static updateCfParamsForAdmin = `${environment.base_url}/masterUser/updateCfParamsForAdmin`;
  static getRelationships = `${environment.base_url}/relationship/getRelationships`;
  static addRelationships = `${environment.base_url}/admin/relationship/createRelationship`;
  static updateContactDetailsForAdmin = `${environment.base_url}/personaliseAdmin/updateContactDetails`;
  static getTransactionReportTemplates = `${environment.base_url}/trxReportTemplate/getTransactionReportTemplates`;
  static createTransactionReportTemplate = `${environment.base_url}/trxReportTemplate/createTransactionReportTemplate`;
  static updateTransactionReportTemplate = `${environment.base_url}/trxReportTemplate/updateTransactionReportTemplate`;
  static deleteTransactionReportTemplate = `${environment.base_url}/trxReportTemplate/deleteTransactionReportTemplate`;
  static getPossibleColumns = `${environment.base_url}/trxReportTemplate/getPossibleColumns`;

  static getPartnerUserList = `${environment.base_url}/partnerUser/getPartnerUsers`;
  static getPartnerUserListById = `${environment.base_url}/partnerUser`;
  static createNewPartnerUser = `${environment.base_url}/partnerUser/create`;
  static updateColorAndCustomUrlForPartner = `${environment.base_url}/personalisePartner/updateColorAndCustomUrl`;
  static logoUploadUrlForPartner = `${environment.base_url}/personalisePartner/uploadUrl`;
  static publicUrlLogoByDocumentIdForPartner = `${environment.base_url}/personalisePartner/getPublicLogoUrl`;
  static addCapabilities = `${environment.base_url}/partner/addCapability`;
  static updateCfParamsForPartner = `${environment.base_url}/masterUser/updateCfParamsForPartner`;
  static getPartnerProcessor = `${environment.base_url}/partnerProcessor/get`;
  static updateContactDetailsForPartner = `${environment.base_url}/personalisePartner/updateContactDetails`;

  static getCustomerUserList = `${environment.base_url}/user/customer/getCustomerUsers`;
  static getCustomerUserListById = `${environment.base_url}/user/customer/getCustomerUserById`;
  static createCustomer = `${environment.base_url}/partner/customer/create`;
  static getCustomerAdditionalDetails = `${environment.base_url}/masterUser/customer/getCustomerAdditionalDetails`;
  static getCreateCustomerUserStatus = `${environment.base_url}/partner/customer/isCustomerCreated`;
  static updateProfileDetails = `${environment.base_url}/customer/profile/updateProfileData`;
  static getCustomerUsersWithExpiredDocuments = `${environment.base_url}/user/customer/getCustomerUsersWithExpiredDocuments`;

  static getExistingLiveness = `${environment.base_url}/user/liveness/getExistingLc`;
  static shareableLinkForLiveness = `${environment.base_url}/user/liveness/getSharableLink`;
  static getEligibleForLivenessCheck = `${environment.base_url}/user/liveness/getEligibleForLiveness`;
  static getExistingSanction = `${environment.base_url}/user/sanction/getExistingSc`;
  static shareableLinkForSanction = `${environment.base_url}/user/sanction/getSharableLink`;
  static getEligibleForSanctionCheck = `${environment.base_url}/user/sanction/getEligibleForSanctionCheck`;

  static getUserAccountStatus = `${environment.base_url}/updateUser/getUserAccountStatusToChange`;
  static updateUserAccountStatus = `${environment.base_url}/updateUser/updateUserAccountStatus`;
  static updateAdminApproverLevel = `${environment.base_url}/masterUser/admin/updateApproverLevel`;
  static updateSubUserApproverLevel = `${environment.base_url}/masterUser/admin/updateSubUserApproverLevel`;
  static getIfUserCanBeChanged = `${environment.base_url}/updateUser/getIfUserCanBeUpdated`;

  static getDocumentList = `${environment.base_url}/document/getAll`;
  static documentUpload = `${environment.base_url}/document/upload`;
  static getPublicUrlByDocumentId = `${environment.base_url}/document/getPublicUrl`;
  static getDocumentCategoryList = `${environment.base_url}/documentCategory`;
  static documentApproveByDocumentId = `${environment.base_url}/document/approve`;
  static documentRejectByDocumentId = `${environment.base_url}/document/reject`;
  static attachExtraParamsToDocument = `${environment.base_url}/document/attachExtraParamsToDocument`;

  static getPaymentRouteList = `${environment.base_url}/paymentRoute/getPaymentRoutes`;
  static createPaymentRoute = `${environment.base_url}/paymentRoute/createPaymentRoute`;
  static getPaymentRouteById = `${environment.base_url}/paymentRoute/getPaymentRouteById`;
  static addQualifier = `${environment.base_url}/qualifier/addQualifier`;

  static getCustomUrlList = `${environment.base_url}/masterUser/getCustomUrls`;
  static killSites = `${environment.base_url}/masterUser/killSite`;
  static goOnline = `${environment.base_url}/masterUser/goOnline`;

  static getUserLogList = `${environment.base_url}/user/getLogs`;
  static getAllApiList = `${environment.base_url}/user/getAllApi`;
  static getUserTypesToFilter = `${environment.base_url}/user/getUserTypesToFilterWith`;

  static getTransactions = `${environment.base_url}/transaction/getTransactions`;
  static getTransactionById = `${environment.base_url}/transaction/getTransactionByIdOrCode`;
  static getEstimateForTransaction = `${environment.base_url}/transaction/getEstimate`;
  static getIngressCountriesForTransaction = `${environment.base_url}/transaction/getIngressCountriesAvailableForTransaction`;
  static getEgressCountriesForTransaction = `${environment.base_url}/transaction/getEgressCountriesAvailableForTransaction`;
  static getIngressCurrenciesForTransaction = `${environment.base_url}/transaction/getIngressCurrenciesAvailableForTransaction`;
  static getEgressCurrenciesForTransaction = `${environment.base_url}/transaction/getEgressCurrenciesAvailableForTransaction`;
  static getPayoutOptionForTransaction = `${environment.base_url}/transaction/getPayoutOptionsForTransaction`;
  static getPaymentOptionForTransaction = `${environment.base_url}/transaction/getPaymentOptionsForTransaction`;
  static createTransaction = `${environment.base_url}/user/transaction/createTransaction`;
  static getCountryByCustomerId = `${environment.base_url}/user/customer/getCountryByCustomerId`;
  static getTransactionStepsByTransactionId = `${environment.base_url}/transaction/getTransactionStepsByTransactionId`;
  static getActionForTransaction = `${environment.base_url}/transaction/getActionForTransaction`;
  static getLinkForLiveness = `${environment.base_url}/user/liveness/getLinkForLiveness`;
  static skipLiveness = `${environment.base_url}/user/liveness/skipLiveness`;
  static initSanctionCheck = `${environment.base_url}/user/sanction/initSanctionCheck`;
  static paymentInit = `${environment.base_url}/user/transaction/paymentInit`;
  static paymentDone = `${environment.base_url}/partner/transaction/paymentDone`;
  static processedToPayoutInProgress = `${environment.base_url}/partner/transaction/processedToPayoutInProgress`;
  static processedToPayoutComplete = `${environment.base_url}/partner/transaction/processedToPayoutComplete`;
  static SARTransactionByTransactionId = `${environment.base_url}/SAR/transaction/byIdOrCode`;
  static documentUploadForTransactionStep = `${environment.base_url}/trxStep/uploadDocxForCurrentStep`;
  static documentShowByTransactionStepId = `${environment.base_url}/trxStep/getDocumentUrl`;
  static getTransactionReport = `${environment.base_url}/transaction/getTransactionReport`;
  static getTransactionReportByCustomTemplate = `${environment.base_url}/customTemplate/getTransactionReport`;
  static getNecessaryDetailsForTransaction = `${environment.base_url}/user/transaction/getNecessaryDetailsForTransaction`;
  static processToReturnInitiated = `${environment.base_url}/transaction/processToReturnInitiated`;
  static processToReturnComplete = `${environment.base_url}/transaction/processToReturnComplete`;
  static processToReturnReject = `${environment.base_url}/transaction/processToReturnReject`;
  static processToReturnFail = `${environment.base_url}/transaction/processToReturnFail`;
  static checkBalanceAtProvidersEnd = `${environment.base_url}/transaction/checkBalanceAtProvidersEnd`;
  static approveRiskCheck = `${environment.base_url}/admin/risk/approve`;

  static getUserType = `${environment.base_url}/enums/userType`;
  static otpDeliveryChannel = `${environment.base_url}/enums/otpDeliveryChannel`;
  static getPartnerType = `${environment.base_url}/enums/partnerType`;
  static getManagedBy = `${environment.base_url}/enums/managedBy`;
  static getDocumentStatus = `${environment.base_url}/enums/documentStatus`;
  static dateRangeType = `${environment.base_url}/enums/dateRangeType`;
  static customerProfileType = `${environment.base_url}/enums/customerProfileType`;
  static modesOfPaymentOrPayout = `${environment.base_url}/enums/modeOfPaymentOrPayout `;
  static timeUnit = `${environment.base_url}/enums/timeUnit`;
  static rateStrategy = `${environment.base_url}/enums/rateStrategy`;
  static refundStrategy = `${environment.base_url}/enums/refundStrategy`;
  static visibilityLevel = `${environment.base_url}/enums/visibilityLevel`;
  static capabilityType = `${environment.base_url}/enums/partnerCapabilityType`;
  static transactionProcessStrategy = `${environment.base_url}/enums/transactionProcessStrategy`;
  static modeOfPaymentOrPayout = `${environment.base_url}/enums/modeOfPaymentOrPayout`;
  static sanctionCheckType = `${environment.base_url}/enums/sanctionCheckType`;
  static approverLevel = `${environment.base_url}/enums/approverLevel`;
  static riskGrade = `${environment.base_url}/enums/riskGrade`;

  static getAffiliateUser = `${environment.base_url}/affiliatePartnerUser/getAffiliatePartnerUsers`;
  static addAffiliateUser = `${environment.base_url}/affiliatePartnerUser/create`;
  static getAffiliateUserById = `${environment.base_url}/affiliatePartnerUser/getAffiliatePartnerUserById`;

  static getSubUser = `${environment.base_url}/getSubUsers`;
  static accessRoleForUser = `${environment.base_url}/accessRole/getRoles`;
  static addSubUser = `${environment.base_url}/createSubUser`;
  static getSubUserById = `${environment.base_url}/getSubUserById`;

  static addaccessRoleForUser = `${environment.base_url}/accessRole/add`;
  static deleteaccessRoleForUser = `${environment.base_url}/user/accessControlPolicy/delete`;
  static getaccesscontrolrolebyId = `${environment.base_url}/accessRole/byId`;
  static addaccessControlPolicy = `${environment.base_url}/user/accessControlPolicy/add`;

  static getapiforexgrabber = `${environment.base_url}/forexGrabber/getAll`;
  static forexgrabberManualName = `${environment.base_url}/forexGrabber/getManualGrabberName`;

  static addAddressFieldSchemaValuesForCustomer = `${environment.base_url}/customer/addAddressFieldSchemaValues`;
  static addBusinessIdentifierFieldSchemaValuesForCustomer = `${environment.base_url}/customer/addBusinessIdentifierFieldSchemaValues`;
  static addIndividualIdentifierFieldSchemaValuesForCustomer = `${environment.base_url}/customer/addIndividualIdentifierFieldSchemaValues`;
  static updateIndividualIdentifierFieldSchemaValuesForCustomer = `${environment.base_url}/customer/updateIndividualIdentifierFieldSchemaValues`;
  static addCustomerSpecificFieldSchemaValuesForCustomer = `${environment.base_url}/customer/addCustomerSpecificFieldSchemaValues`;
  static addAddressFieldSchemaValuesForAdmin = `${environment.base_url}/admin/addAddressFieldSchemaValues`;
  static addBusinessIdentifierFieldSchemaValuesForAdmin = `${environment.base_url}/admin/addBusinessIdentifierFieldSchemaValues`;
  static addIndividualIdentifierFieldSchemaValuesForAdmin = `${environment.base_url}/admin/addIndividualIdentifierFieldSchemaValues`;
  static updateIndividualIdentifierFieldSchemaValuesForAdmin = `${environment.base_url}/admin/updateIndividualIdentifierFieldSchemaValues`;
  static addAdminSpecificFieldSchemaValuesForAdmin = `${environment.base_url}/admin/addAdminSpecificFieldSchemaValues`;
  static addAddressFieldSchemaValuesForPartner = `${environment.base_url}/partner/addAddressFieldSchemaValues`;
  static addBusinessIdentifierFieldSchemaValuesForPartner = `${environment.base_url}/partner/addBusinessIdentifierFieldSchemaValues`;
  static addIndividualIdentifierFieldSchemaValuesForPartner = `${environment.base_url}/partner/addIndividualIdentifierFieldSchemaValues`;
  static updateIndividualIdentifierFieldSchemaValuesForPartner = `${environment.base_url}/partner/updateIndividualIdentifierFieldSchemaValues`;
  static addPartnerSpecificFieldSchemaValuesForPartner = `${environment.base_url}/partner/addPartnerSpecificFieldSchemaValues`;
  static getFieldSchemaValuesSuggestionToLock = `${environment.base_url}/customer/getFieldSchemaValuesSuggestionToLock`;

  static getapiallcurriencies = `${environment.base_url}/currency/all`;
  static createapiforexgrabber = `${environment.base_url}/forexGrabber/add`;
  static expirytype = `${environment.base_url}/enums/ForexDataExpiryType`;
  static ForexFeederRunIntervalUnit = `${environment.base_url}/enums/ForexFeederRunIntervalUnit`;
  static grabberbyid = `${environment.base_url}/forexGrabber/getById`;
  static editapiforexgrabber = `${environment.base_url}/forexGrabber/update`;
  static getGrabbersName = `${environment.base_url}/forexGrabber/getGrabbersName`;

  static getapiforexall = `${environment.base_url}/forex/getAll`;
  static apiforexurl = `${environment.base_url}/forex/addForex`;
  static getSuggestForex = `${environment.base_url}/forexGrabber/suggestForex`;

  static getAllPaymentInstrument = `${environment.base_url}/paymentInstrument/getAll`;
  static addCost = `${environment.base_url}/paymentInstrument/addCost`;
  static createPaymentInstrument = `${environment.base_url}/paymentInstrument/create`;
  static getImplClasses = `${environment.base_url}/paymentInstrument/implClasses`;
  static getPaymentInstrumentById = `${environment.base_url}/paymentInstrument/getPaymentInstrumentById`;

  static getTimeUnit = `${environment.base_url}/enums/TimeUnit`;
  static santioncheckType = `${environment.base_url}/enums/SanctionCheckType`;
  static updateForAll = `${environment.base_url}/lcsc/updateAll`;
  static updateForAdmin = `${environment.base_url}/lcsc/updateAdminUsers`;
  static updateForPartner = `${environment.base_url}/lcsc/updatePartnerUsers`;
  static updateForCustomer = `${environment.base_url}/lcsc/updateCustomerUsers`;
  static lcscUpdate = `${environment.base_url}/lcsc/updateByUserId`;
  static lcscDelete = `${environment.base_url}/lcsc/delete`;
  static getAllNotificationConfig = `${environment.base_url}/notificationConfig/getAllConfigs`;
  static updateNotificationConfig = `${environment.base_url}/notificationConfig/update`;
  static notificationBannerType = `${environment.base_url}/enums/notificationBannerType`;
  static notificationBannerDestination = `${environment.base_url}/enums/notificationBannerDestination`;
  static fileExtension = `${environment.base_url}/enums/fileExtension`;

  static getAllRiskFactors = `${environment.base_url}/risk/getAllRiskFactors`;
  static createRiskFactor = `${environment.base_url}/masterUser/risk/createRiskFactor`;
  static getRiskFactorClasses = `${environment.base_url}/masterUser/risk/getImplClassForRiskFactor`;
  static updateRiskParams = `${environment.base_url}/risk/updateRiskParams`;
  static getAllRiskCalculator = `${environment.base_url}/risk/getAllRiskCalculators`;
  static createRiskCalculator = `${environment.base_url}/risk/createRiskCalculator`;
  static attachRiskToAdmin = `${environment.base_url}/admin/risk/attachRiskToAdmin`;
  static attachRiskToAdminForCustomer = `${environment.base_url}/admin/risk/attachRiskToAdminForCustomer`;
  static attachRiskToPartner = `${environment.base_url}/risk/attachRiskToPartner`;
  static createRiskFactorImplementation = `${environment.base_url}/risk/createRiskFactorImpl`;
  static getRiskCalculatorEvaluation = `${environment.base_url}/risk/getRiskCalculatorEvaluation`;

  static getReceiverList = `${environment.base_url}/receiver/getReceivers`;
  static addReceiver = `${environment.base_url}/customer/receiver/create`;
  static updateReceiver = `${environment.base_url}/customer/receiver/update`;
  static addPaymentSchema = `${environment.base_url}/customer/receiver/addPaymentDetailsFieldSchemaValues`;
  static receiverbyId = `${environment.base_url}/receiver/byId`;
  static customerById = `${environment.base_url}/user/customer/getCustomerUsers`;
  static getLatestProfileRiskResults = `${environment.base_url}/admin/customerProfileRisk/getLatestProfileRiskResults`;
  static getProfileRiskResults = `${environment.base_url}/admin/customerProfileRisk/getProfileRiskResults`;
  static approveCustomerProfileRiskCheckFromFlagged = `${environment.base_url}/admin/customerProfileRisk/approve`;

  static getRiskCalculatorById = `${environment.base_url}/risk/getRiskCalculatorById`;
  static updateRiskCalculator = `${environment.base_url}/risk/updateRiskCalculator`;
  static getRiskFactorById = `${environment.base_url}/risk/getRiskFactorById`;
  static updateRiskFactor = `${environment.base_url}/masterUser/risk/updateRiskFactor`;
  static getAttachedRiskImpl = `${environment.base_url}/risk/getRiskFactorImplByRiskCalculator`;
  static updateRiskFactorImpl = `${environment.base_url}/risk/updateRiskFactorImpl`;
  static calculatorCustomerAttachemnt = `${environment.base_url}/risk/getIfCalculatorAttachedForCustomer`;

  static getAllWeekSchedule = `${environment.base_url}/partner/getAllWeekSchedule`;
  static getWeekScheduleById = `${environment.base_url}/partner/getWeekScheduleById`;
  static addPartnerWeekSchedule = `${environment.base_url}/partner/addWeekSchedule`;
  static updatePartnerWeekSchedule = `${environment.base_url}/partner/updateWeekSchedule`;
  static getWeekScheduleByPartnerId = `${environment.base_url}/partner/getWeekScheduleByPartnerId`;
  static getAllScheduleException = `${environment.base_url}/partner/getAllScheduleException`;
  static updateScheduleException = `${environment.base_url}/partner/updateScheduleException`;
  static addScheduleException = `${environment.base_url}/partner/addScheduleException`;
  static disableScheduleException = `${environment.base_url}/partner/disableScheduleException`;

  static getQueueMaster = `${environment.base_url}/queue/getQueueMasters`;
  static getQueueMasterResponseByState = `${environment.base_url}/queue/getQueueMasterCountResponseByState`;
  static getQueueMasterState = `${environment.base_url}/enums/queueMasterState`;
  static updateQueuemasterState = `${environment.base_url}/queue/updateQueueMasterState`;

  static getTransactionStat = `${environment.base_url}/transaction/getTransactionStat`;
  static getProviderBalances = `${environment.base_url}/transaction/getProviderBalances`;

  public static readonly getAllRiskGradeList: string = `${environment.base_url}/riskGrade/getAll`;
  public static readonly getRiskGradeById: string = `${environment.base_url}/riskGrade/getRiskGradeDataById`;
  public static readonly updateRiskGradeData: string = `${environment.base_url}/riskGrade/updateRiskGradeData`;
  public static readonly disableRiskGrade: string = `${environment.base_url}/riskGrade/disableRiskGradeData/`;

  static createPurpose = `${environment.base_url}/admin/purpose/createPurpose`;
  static getPurpose = `${environment.base_url}/purpose/getPurposes`;
  static transactionDocument = `${environment.base_url}/transaction/getPublicUrlForTransactionDocument`;

  public static readonly getAllSarList: string = `${environment.base_url}/SAR/transaction/getAll`;

  static getSharableLinkForTransactionMiscVars = `${environment.base_url}/transaction/getSharableLinkForTransactionMiscVars`;
  static getPayoutSchemaValueOptionsForTransaction = `${environment.base_url}/transaction/getPayoutSchemaValueOptionsForTransaction`;

  static overrideCheckForKYC = `${environment.base_url}/transaction/kyc/override`;
  static overrideCheckForLiveness = `${environment.base_url}/liveness/override`;
  static overrideCheckForSanction = `${environment.base_url}/sanction/override`;
  static overrideCheckForSarRisk = `${environment.base_url}/SAR/transaction/override`;

  static customerAddressAddFromPartner = `${environment.base_url}/partner/customer/addAddressFieldSchemaValues`;
  static individualDataAddFromPartner = `${environment.base_url}/partner/customer/addIndividualIdentifierFieldSchemaValues`;
  static miscDataAddFromPartner = `${environment.base_url}/partner/customer/addCustomerMiscFieldSchemaValues`;
  static businessDataAddFromPartner = `${environment.base_url}/partner/customer/addBusinessIdentifierFieldSchemaValues`;
  static individualDataUpdateFromPartner = `${environment.base_url}/partner/customer/updateIndividualIdentifierFieldSchemaValues`;
  static getFieldSchemaSuggestionsToLock = `${environment.base_url}/partner/customer/getFieldSchemaValuesSuggestionToLock`;

  public static readonly updateSMTPConfiguration = `${environment.base_url}/personaliseAdmin/updateSMTPConfiguration`;

  public static readonly checkProfileCompletionStatusCustomer = `${environment.base_url}/customer/checkProfileCompletionStatus`;
  static editapisupportemail = `${environment.base_url}/personaliseAdmin/updateColorAndCustomUrl`;
  static customerOccupation = `${environment.base_url}/occupation/getOccupation`;
  static customerEditOccupation = `${environment.base_url}/customer/attachOccupation`;
  static addOccupations = `${environment.base_url}/admin/occupation/createOccupation`;
  static editOccupations = `${environment.base_url}/admin/occupation/updateOccupationRiskScore`;
  static ageRangeUrl = `${environment.base_url}/admin/ageRiskBracket/getAgeRiskBracket`;
  static ageRangeAdd = `${environment.base_url}/admin/ageRiskBracket/createAgeRiskBracket`;
  static ageRangeEdit = `${environment.base_url}/admin/ageRiskBracket/updateAgeRiskBracketRiskScore`;
  static customerriskparam = `${environment.base_url}/admin/customerProfileRiskParams/update`;

  public static readonly getRiskScoreByCountryId = `${environment.base_url}/admin/countryRiskConfig/getCountryRiskConfig`;
  public static readonly createCountryRiskConfig = `${environment.base_url}/admin/countryRiskConfig/createCountryRiskConfig`;
  public static readonly updateCountryRiskConfig = `${environment.base_url}/admin/countryRiskConfig/updateCountryRiskConfigRiskScore`;


  static getCreditLineAccounts = `${environment.base_url}/creditLine/getAccounts`;
  static creditLineAdjustment = `${environment.base_url}/admin/creditLine/adjustment`;
  static getCashReconciliationAllData = `${environment.base_url}/cashReconciliation/getAllData`;
  static documentUploadForCashReconciliation = `${environment.base_url}/cashReconciliation/uploadDocument`;
  static documentShowByCashReconciliationId = `${environment.base_url}/cashReconciliation/getDocumentUrl`;


  static clientDevicePlatform: string = `${environment.base_url}/enums/ClientDevicePlatform`;
  static getClientPlatform: string = `${environment.base_url}/clientPlatform/getByAdminUserId`;
  static addClientPlatform: string = `${environment.base_url}/master/clientPlatform/add`;
  static updateClientPlatform: string = `${environment.base_url}/master/clientPlatform/update`;
}
